<template>
	<perfect-scrollbar class="group-users">
		<div>
			<div>
				<v-simple-table class="users_table" fixed-header>
					<template v-slot:default>
						<thead>
							<tr>
								<th class="text-left">Name</th>
								<th class="text-left">Email</th>
								<th class="text-left">{{ subGroupsText }}</th>
								<th class="text-left">Ply space membership</th>
							</tr>
						</thead>
						<tbody v-if="users.length > 0">
							<tr
								v-for="user in users"
								:key="getUserKey(user)"
								@mouseover="mouseOver(user)"
								@mouseleave="mouseLeave(user)"
								class="no-select user"
							>
								<td>{{ user.name }}</td>
								<td>{{ user.email }}</td>
								<td>{{ groupsCount(user) }}</td>
								<td>
									<span>{{ getWorkspaceStatus(user) }}</span>
								</td>
							</tr>
						</tbody>
						<tr v-else>
							<span>No Users</span>
						</tr>
					</template>
				</v-simple-table>
			</div>
		</div>
	</perfect-scrollbar>
</template>

<script>
import { mapActions } from 'vuex';
import { AccountPermissions } from '@ply-io/ply-front-shared-utilities';
import { teamMembers, hasAccountPermission } from '@/store/modules/account/getters';
import { createGroup } from '@/store/modules/accountGroups/actions';
import { mapGettersShorthand } from '@/store/utils/mappers';
export default {
	name: 'SyncedGroupUsers',
	components: {},
	props: {
		users: { type: Array },
		groups: { type: Array },
		subGroupsText: { type: String, default: 'Sub groups' },
	},
	computed: {
		...mapGettersShorthand({ hasAccountPermission, teamMembers }),
		allowedToInvite() {
			return this.hasAccountPermission(AccountPermissions.InviteUsers);
		},
	},
	methods: {
		...mapActions([createGroup.fullPath]),
		getUserKey(user) {
			return user.id;
		},
		mouseOver(user) {
			this.hoverLine = this.getUserKey(user);
		},
		mouseLeave() {
			this.hoverLine = -1;
		},
		getWorkspaceStatus(user) {
			const found = this.teamMembers.find((x) => x.email === user.email);
			if (found) {
				return 'Already a member';
			}
			return this.NEEDS_INVITE;
		},
		isInvited(user) {
			return this.invitedUsers.includes(user.id);
		},
		inviteUser(user) {
			if (!this.isInvited(user)) {
				this.invitedUsers.push(user.id);
				this.$emit('inviteUser', user.email);
			}
		},
		btnText(user) {
			return this.isInvited(user) ? 'Will be invited' : 'Invite';
		},
		groupsCount(user) {
			return this.groups.filter((g) => g.members.includes(user.id))?.length || 0;
		},
	},
	async mounted() {},
	data: () => ({
		hoverLine: -1,
		invitedUsers: [],
		NEEDS_INVITE: 'Not a member yet',
	}),
};
</script>

<style scoped lang="scss">
.group-users {
	th {
		border-bottom: 1px solid #93a1bb !important;
		color: #354052 !important;
		font-weight: 600 !important;
		font-size: 11px !important;
		padding-bottom: 0px !important;
		line-height: 20px !important;
		height: 36px !important;
	}
	td {
		border-bottom: 1px solid #eff1f7 !important;
		font-size: 11px !important;
		height: 20px !important;
	}
	.user {
		cursor: pointer;
	}
	.flexJustifyEnd {
		justify-content: flex-end;
	}
	.v-data-table {
		background-color: inherit;
	}
	.v-data-table.v-data-table--fixed-header thead th {
		background-color: inherit;
	}
}
</style>
